import { securedAxiosInstance } from "../axios";
import { toSnakeCase } from "@estaly/ui";

class InvoicesService {
  fetchIndex(page, filteringData) {
    return securedAxiosInstance.post("/admin/invoices", filteringData, { params: { page } });
  }

  fetch(friendlyId) {
    return securedAxiosInstance.get(`/admin/invoices/${friendlyId}`);
  }

  fetchBreakdown(friendlyId, data) {
    return securedAxiosInstance.get(`/admin/invoices/${friendlyId}/breakdown`, { params: data });
  }

  fetchItems(friendlyId) {
    return securedAxiosInstance.get(`/invoices/${friendlyId}/invoice_items`);
  }

  fetchSummary(params) {
    return securedAxiosInstance.get("/admin/invoices/summary", { params: toSnakeCase(params) });
  }
}

export default new InvoicesService();
